/* ==========================================================================
   MX theme – mx-pc-builder-util.js   (sections/mx-pc-builder.liquid)
   Helpers and the summary, link and cart methods of <mx-pc-builder>. Load before mx-pc-builder.js.
   ========================================================================== */
(function () {
  'use strict';
  if (window.MXPcb) return;
  function money(cents) {
    if (window.MXTheme && MXTheme.money) return MXTheme.money(cents);
    return 'Rs.' + Math.round(cents / 100).toLocaleString('en-PK');
  }
  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function icon(name) {
    var paths = {
      check: '<path d="m5 12.5 4.2 4.2L19 7"/>',
      plus: '<path d="M12 5v14M5 12h14"/>',
      minus: '<path d="M5 12h14"/>',
      close: '<path d="M6 6l12 12M18 6 6 18"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (paths[name] || '') + '</svg>';
  }

  window.MXPcb = {
    money: money, fill: fill, el: el, icon: icon,
    methods: {
    /* ---------------- summary */
    lines() {
      var self = this, out = [];
      this.steps.forEach(function (st) {
        self.state[st.id].forEach(function (pk) {
          var info = self.byVariant[pk.v];
          if (info) out.push({ step: st, product: info.product, variant: info.variant, q: pk.q });
        });
      });
      return out;
    },
    missingSteps() {
      var self = this;
      return this.steps.filter(function (st) { return st.required && st.products.length && !self.state[st.id].length; });
    },

    update(initial) {
      var self = this;
      var lines = this.lines();
      var total = 0, count = 0;
      lines.forEach(function (l) { total += l.variant.p * l.q; count += l.q; });

      this.steps.forEach(function (st) {
        var picks = self.state[st.id];
        st.node.classList.toggle('is-done', picks.length > 0);
        st.node.classList.toggle('is-skipped', !picks.length && st.skipped);
        var names = [], sub = 0;
        picks.forEach(function (pk) {
          var info = self.byVariant[pk.v];
          if (!info) return;
          names.push((pk.q > 1 ? pk.q + ' × ' : '') + info.product.t + (info.product.v.length > 1 ? ' (' + info.variant.t + ')' : ''));
          sub += info.variant.p * pk.q;
        });
        st.pick.textContent = names.length ? names.join(', ') : st.hint;
        st.price.textContent = names.length ? money(sub) : '';
        if (!initial) self.renderStep(st);
      });

      // summary list
      if (this.list) {
        this.list.textContent = '';
        this.steps.forEach(function (st) {
          var picks = self.state[st.id];
          if (!st.products.length) return;
          if (!picks.length) {
            var li = el('li', 'mxpcb-sum__row is-empty');
            var b = el('button', 'mxpcb-sum__step');
            b.type = 'button';
            b.innerHTML = '<span></span><em></em>';
            b.firstChild.textContent = st.title;
            b.lastChild.textContent = st.skipped ? '—' : self.L.none;
            b.addEventListener('click', function () { self.open(st, true); });
            li.appendChild(b);
            self.list.appendChild(li);
            return;
          }
          picks.forEach(function (pk) {
            var info = self.byVariant[pk.v];
            if (!info) return;
            var li = el('li', 'mxpcb-sum__row');
            var txt = el('div', 'mxpcb-sum__txt');
            txt.appendChild(el('span', 'mxpcb-sum__label', st.title));
            txt.appendChild(el('span', 'mxpcb-sum__name', (pk.q > 1 ? pk.q + ' × ' : '') + info.product.t + (info.product.v.length > 1 ? ' – ' + info.variant.t : '')));
            li.appendChild(txt);
            li.appendChild(el('span', 'mxpcb-sum__price mx-num', money(info.variant.p * pk.q)));
            var rm = el('button', 'mxpcb-sum__rm');
            rm.type = 'button';
            rm.setAttribute('aria-label', self.L.remove + ': ' + info.product.t);
            rm.innerHTML = icon('close');
            rm.addEventListener('click', function () {
              var arr = self.state[st.id];
              arr.splice(arr.indexOf(pk), 1);
              self.update();
            });
            li.appendChild(rm);
            self.list.appendChild(li);
          });
        });
      }

      if (this.totalEl) this.totalEl.textContent = money(total);
      if (this.countEl) this.countEl.textContent = count ? fill(this.L.items, { count: count }) : '';
      this.total = total; this.count = count;

      var missing = this.missingSteps();
      if (this.missingEl) {
        this.missingEl.hidden = !(this.require && missing.length && count);
        this.missingEl.textContent = fill(this.L.missing, { steps: missing.map(function (s) { return s.title; }).join(', ') });
      }
      if (this.resetBtn) this.resetBtn.hidden = !count;
      if (this.shareBtn) this.shareBtn.hidden = !count;
      if (this.cartBtn) this.cartBtn.disabled = !count;
      this.updateWa();
      this.writeHash();
      this.updateBar();
    },

    updateBar() {
      if (!this.bar) return;
      this.bar.hidden = !this.count || !!this._sumVisible;
      document.documentElement.classList.toggle('mxpcb-bar-on', !this.bar.hidden);
      var c = this.bar.querySelector('[data-bar-count]');
      var t = this.bar.querySelector('[data-bar-total]');
      if (c) c.textContent = fill(this.L.items, { count: this.count || 0 });
      if (t) t.textContent = money(this.total || 0);
    },

    message() {
      var M = this.M, lines = this.lines(), out = [];
      out.push(M.intro);
      out.push('');
      var self = this;
      lines.forEach(function (l, i) {
        var name = l.product.t + (l.product.v.length > 1 ? ' (' + l.variant.t + ')' : '');
        out.push((i + 1) + ') ' + l.step.title + ': ' + name + (l.q > 1 ? ' × ' + l.q : '') + ' – ' + money(l.variant.p * l.q));
        if (M.links) out.push('   ' + self.dataset.shopUrl + l.product.u);
      });
      out.push('');
      out.push(M.total + ': ' + money(this.total) + ' (' + fill(this.L.items, { count: this.count }) + ')');
      var f = this.fields;
      var name = f.name && f.name.value.trim(), city = f.city && f.city.value.trim(), note = f.note && f.note.value.trim();
      if (name || city || note) out.push('');
      if (name) out.push(M.name + ': ' + name);
      if (city) out.push(M.city + ': ' + city);
      if (note) out.push(M.note + ': ' + note);
      out.push('');
      out.push(M.link + ': ' + this.buildUrl());
      return out.join('\n');
    },

    updateWa() {
      if (!this.wa) return;
      var blocked = !this.count || (this.require && this.missingSteps().length > 0);
      var url = (!blocked && window.MXTheme && MXTheme.whatsapp) ? MXTheme.whatsapp(this.message()) : '';
      this.wa.setAttribute('aria-disabled', blocked || !url ? 'true' : 'false');
      this.wa.href = url || '#';
    },

    /* ---------------- link state */
    code() {
      var self = this, parts = [];
      this.steps.forEach(function (st) {
        self.state[st.id].forEach(function (pk) { parts.push(pk.v + 'x' + pk.q); });
      });
      return parts.join('.');
    },
    buildUrl() {
      var c = this.code();
      return location.origin + location.pathname + (c ? '#build=' + c : '');
    },
    writeHash() {
      var c = this.code();
      var want = c ? '#build=' + c : '';
      if ((location.hash || '') === want) return;
      try { history.replaceState(history.state, '', location.pathname + location.search + (want || '')); } catch (e) { /* ignore */ }
    },
    readHash() {
      var m = /build=([\dx.]+)/.exec(location.hash || '');
      if (!m) return;
      var self = this;
      m[1].split('.').forEach(function (part) {
        var bits = part.split('x');
        var vid = parseInt(bits[0], 10), q = parseInt(bits[1], 10) || 1;
        var info = self.byVariant[vid];
        if (!info || !info.variant.a) return;
        var st = self.steps.filter(function (s) { return s.id === info.step; })[0];
        if (!st) return;
        var picks = self.state[st.id];
        if (!st.multi && picks.length) return;
        if (picks.some(function (pk) { return self.byVariant[pk.v].product.id === info.product.id; })) return;
        picks.push({ v: vid, q: Math.min(st.max, q) });
      });
    },
    copyLink() {
      var url = this.buildUrl(), self = this;
      var done = function () { self.announce(self.L.copied); if (window.MXTheme && MXTheme.toast) MXTheme.toast(self.L.copied); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
      else window.prompt('', url);
    },

    /* ---------------- cart */
    addToCart() {
      var self = this;
      var items = this.lines().map(function (l) { return { id: l.variant.id, quantity: l.q }; });
      if (!items.length || !(window.MXTheme && MXTheme.cart)) return;
      this.cartBtn.disabled = true;
      MXTheme.cart.add({ items: items }, { open: true, toast: true }).then(function () {
        self.announce(self.L.added);
      }, function (err) {
        var msg = (err && err.message) || self.L.error;
        if (MXTheme.toast) MXTheme.toast(msg);
        self.announce(msg);
      }).then(function () { self.cartBtn.disabled = !self.count; });
    }

    }
  };
  window.dispatchEvent(new Event('mxpcb:util'));
})();